import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { quotePropertyName } from '@cli-utils/text.js'
import { defaultFallbackValue } from './default-fallback-value.js'
import { propertyAccessExpression } from './property-access-expression.js'

export function generateNestedFieldDefaultExpression(
  field: SchemaField,
  dataSource: string,
  depth = 1
): string {
  const fieldSource = propertyAccessExpression(dataSource, field.name)

  if ((field.type === 'group' || field.type === 'section') && field.fields?.length) {
    const values = field.fields.flatMap((nestedField) => {
      const fieldDefault = `${quotePropertyName(nestedField.name)}: ${generateNestedFieldDefaultExpression(nestedField, fieldSource, depth)}`
      if (!nestedField.hasIcon) return [fieldDefault]

      const iconName = `${nestedField.name}Icon`
      return [
        fieldDefault,
        `${quotePropertyName(iconName)}: ${propertyAccessExpression(fieldSource, iconName)} ?? ''`
      ]
    })

    return `{ ${values.join(', ')} }`
  }

  if (field.type === 'list' && field.fields?.length) {
    const itemName = `nestedItem${depth}`
    const values = field.fields.flatMap((nestedField) => {
      const fieldDefault = `${quotePropertyName(nestedField.name)}: ${generateNestedFieldDefaultExpression(nestedField, itemName, depth + 1)}`
      if (!nestedField.hasIcon) return [fieldDefault]

      const iconName = `${nestedField.name}Icon`
      return [
        fieldDefault,
        `${quotePropertyName(iconName)}: ${propertyAccessExpression(itemName, iconName)} ?? ''`
      ]
    })

    return `(${fieldSource} ?? []).map((${itemName}) => ({ ${values.join(', ')} }))`
  }

  return `${fieldSource} ?? ${defaultFallbackValue(field)}`
}
